/* eslint-disable no-restricted-imports -- this is one of the only places we should be importing @khanacademy/perseus */
import "./perseus.css";

import {Dependencies} from "@khanacademy/perseus";
import * as Perseus from "@khanacademy/perseus";

import {webappDependencies} from "./webapp-dependencies.ts";

export * from "@khanacademy/perseus";

export {scorePerseusItem, getWidgetScorer} from "@khanacademy/perseus-score";

export {Renderer} from "./renderers/renderer.tsx";
export {HintRenderer} from "./renderers/hint-renderer.tsx";
export {HintsRenderer} from "./renderers/hints-renderer.tsx";
export {ArticleRenderer} from "./renderers/article-renderer.tsx";
export {ServerItemRenderer} from "./renderers/server-item-renderer.tsx";
export {PerseusI18nProviderWrapper} from "./renderers/perseus-i18n-provider-wrapper.tsx";
export {webappDependenciesV2} from "./webapp-dependencies.ts";

export type {Renderer as RendererComponent} from "@khanacademy/perseus";

// This must be called once before calling Perseus.init();
Dependencies.setDependencies(webappDependencies);
// This must be called before using any Perseus components as it both
// registers the Perseus widgets and replaces all of the deprecated widgets.
// This is the one and only place in webapp that we will need to call this
// as everything else is routed through this file when code imports "perseus".
Perseus.init();
